var _defs, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowHorizontalFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "10px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrow",
    markerWidth: 100,
    markerHeight: 10,
    refX: 0,
    refY: 3,
    orient: "auto",
    markerUnits: "strokeWidth"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L9,3 z",
    fill: "#bebebe"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 5,
    x2: "98%",
    y2: 5,
    stroke: "#bebebe",
    strokeWidth: 1,
    markerEnd: "url(#arrow)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowHorizontalFull);
export default __webpack_public_path__ + "static/media/arrow-horizontal-full.7e0590d436b2c96c32694ab4f8e253de.svg";
export { ForwardRef as ReactComponent };